import { useEffect } from 'react'

import { UseFormReturn, useWatch } from 'react-hook-form'

import { OrderSimulationSchema } from '~/pages/Simulation/schemas'

type Props = {
  formMethods: UseFormReturn<OrderSimulationSchema>
  index: number
}

export function useSyncLegs({ formMethods, index }: Props): void {
  const baseSummaryOrder = useWatch({
    control: formMethods.control,
    name: `orderPattern.${index}.baseSummaryOrder`,
  })

  const exchangeSummaryOrder = useWatch({
    control: formMethods.control,
    name: `orderPattern.${index}.exchangeSummaryOrder`,
  })

  useEffect(() => {
    const baseTransactions = formMethods.getValues(
      `orderPattern.${index}.baseTransactions`,
    )

    if (baseTransactions === undefined || baseTransactions.length === 0) {
      return
    }

    for (let i = 0; i < baseTransactions.length; i++) {
      if (baseTransactions[i].areaCode !== baseSummaryOrder.areaCode) {
        formMethods.setValue(
          `orderPattern.${index}.baseTransactions.${i}.areaCode`,
          baseSummaryOrder.areaCode,
        )
      }

      if (
        baseTransactions[i].deliveryHourType !==
        baseSummaryOrder.deliveryHourType
      ) {
        formMethods.setValue(
          `orderPattern.${index}.baseTransactions.${i}.deliveryHourType`,
          baseSummaryOrder.deliveryHourType,
        )
      }

      if (baseTransactions[i].volumeInKw !== baseSummaryOrder.volumeInKw) {
        formMethods.setValue(
          `orderPattern.${index}.baseTransactions.${i}.volumeInKw`,
          baseSummaryOrder.volumeInKw,
        )
      }
    }
  }, [baseSummaryOrder, formMethods, index])

  useEffect(() => {
    const exchangeTransactions = formMethods.getValues(
      `orderPattern.${index}.exchangeTransactions`,
    )

    if (
      exchangeTransactions === undefined ||
      exchangeTransactions.length === 0 ||
      exchangeSummaryOrder === undefined
    ) {
      return
    }

    for (let i = 0; i < exchangeTransactions.length; i++) {
      if (exchangeTransactions[i].areaCode !== exchangeSummaryOrder.areaCode) {
        formMethods.setValue(
          `orderPattern.${index}.exchangeTransactions.${i}.areaCode`,
          exchangeSummaryOrder.areaCode,
        )
      }

      if (
        exchangeTransactions[i].deliveryHourType !==
        exchangeSummaryOrder.deliveryHourType
      ) {
        formMethods.setValue(
          `orderPattern.${index}.exchangeTransactions.${i}.deliveryHourType`,
          exchangeSummaryOrder.deliveryHourType,
        )
      }

      if (
        exchangeTransactions[i].volumeInKw !== exchangeSummaryOrder.volumeInKw
      ) {
        formMethods.setValue(
          `orderPattern.${index}.exchangeTransactions.${i}.volumeInKw`,
          exchangeSummaryOrder.volumeInKw,
        )
      }
    }
  }, [exchangeSummaryOrder, formMethods, index])
}
